module.exports = __webpack_public_path__ + "static/media/battlefield.bf3488a2.png";